import { getCompactCopyWithoutCustomLabels } from "../util/getCompactCopyWithoutCustomLabels.js";
import { makeRacemic } from '../util/makeRacemic.js';
import { tagAtom } from "../util/tagAtom.js";
/**
 * Computes a canonical ID for each atom in `moleculeWithH` by tagging it
 * and calling `getCanonizedIDCode`.
 * By default (`racemic: false`) the ID encodes absolute stereochemistry so
 * enantiomers produce distinct IDs — suitable as independent cache keys for
 * pro-R / pro-S assignment.
 * With `racemic: true` the probe is first racemized (same logic as `diaIDs`),
 * yielding IDs that are identical for both enantiomers.
 * @param topicMolecule
 * @param options
 */
export function getEnantioIDs(topicMolecule, options = {}) {
    const { racemic = false } = options;
    const moleculeWithH = topicMolecule.moleculeWithH;
    const { Molecule } = moleculeWithH.getOCL();
    const heterotopicSymmetryRanks = topicMolecule.heterotopicSymmetryRanks;
    const ids = new Array(moleculeWithH.getAllAtoms());
    const cache = {};
    for (let i = 0; i < moleculeWithH.getAllAtoms(); i++) {
        const rank = heterotopicSymmetryRanks[i];
        if (rank && cache[rank]) {
            ids[i] = cache[rank];
            continue;
        }
        const tempMolecule = getCompactCopyWithoutCustomLabels(moleculeWithH);
        tagAtom(tempMolecule, i);
        if (racemic)
            makeRacemic(tempMolecule);
        const id = tempMolecule.getCanonizedIDCode(Molecule.CANONIZER_ENCODE_ATOM_CUSTOM_LABELS);
        ids[i] = id;
        if (rank)
            cache[rank] = id;
    }
    return ids;
}
//# sourceMappingURL=getEnantioIDs.js.map